import styled from 'styled-components'
import { Button } from '@sketch/components'

export const AddButton = styled(Button)<{
  $toolbar: boolean
  size: '32'
}>`
  padding: 4px 8px;
  height: 32px;
  border: none;
  box-shadow: none;

  && svg {
    color: currentColor;
    display: block;
    width: 24px;
    height: 24px;
  }
  ${({ theme, $toolbar }) =>
    $toolbar &&
    `background-color: transparent;
     color: ${theme.colors.foreground.secondary.D};
     &:hover {
        background-color: ${theme.colors.background.tertiary.C};
     }
    &[disabled] {
      cursor: not-allowed;
      pointer-events: none;
      color: ${theme.colors.state.disabled};
    }
  `};
`

export const CancelButton = styled(Button)``

export const ShortcutText = styled.div`
  color: ${({ theme }) => theme.colors.ui.tooltips.shortcutText};

  @media (hover: none) and (pointer: coarse) {
    /* Hide this so mobile devices should not see it */
    display: none;
  }
`
